import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import closeIcon from "../../../assets/icons/closeIcon.svg";
import { CustomerFilterOptionsProps } from "./customer-filter.props";
import "./customer-filter.scss";
import EmailFilter from "./customer-filter-options/email-filter";
import FirstNameFilter from "./customer-filter-options/first-name-filter";
import LastNameFilter from "./customer-filter-options/last-name-filter";
import CompanyFilter from "./customer-filter-options/company-filter";
import CreatedTimeFilter from "./customer-filter-options/created-time-filter";
import dayjs, { Dayjs } from "dayjs";
import { isOnlyCountryCode } from "../../../utils/utils";
import CustomerOwnerFilter from "./customer-filter-options/customer-owner-filter";
import LeadSourceFilter from "./customer-filter-options/customer-source-filter";

const CustomerFilterOptions: React.FC<CustomerFilterOptionsProps> = (
  props: any
) => {
  const {
    setSelectedCustomersFilters,
    setIsOpenFilter,
    isOpenFilter,
    selectedCustomersFilterOptions,
    setSelectedCustomersFilterOptions,
    onApplyFilters,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    isAssign = true,
    activeFilters,
  } = props;
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [company, setCompany] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [leadSourceError, setCustomerSourceError] = useState("");
  const [dateOfBirthRange, setDateOfBirthRange] = useState<string[]>([]);
  const [dateOfBirthRangeError, setDateOfBirthRangeError] = useState("");
  const [dateOfBirthFrom, setDateOfBirthFrom] = useState<Dayjs | null>(null);
  const [dateOfBirthTo, setDateOfBirthTo] = useState<Dayjs | null>(null);
  const [dateOfBirthFromError, setDateOfBirthFromError] = useState("");
  const [dateOfBirthToError, setDateOfBirthToError] = useState("");
  const [createdByUserIds, setCreatedByUserIds] = useState<number[]>([]);
  const [leadOwnerIds, setCustomerOwnerIds] = useState<number[]>([]);
  const [leadOwnerIdsError, setCustomerOwnerIdsError] = useState("");
  const [source, setSource] = useState<string[]>([]);
  const [
    draftSelectedCustomersFilterOptions,
    setDraftSelectedCustomersFilterOptions,
  ] = useState<any[]>([]);
  useEffect(() => {
    if (isOpenFilter) {
      const updatedDraft = selectedCustomersFilterOptions.map((option: any) => {
        switch (option.label) {
          case "Date of Birth":
            return {
              ...option,
              value: !!(
                activeFilters?.dateOfBirthFrom && activeFilters?.dateOfBirthTo
              ),
            };
          case "Customer Owner":
            return {
              ...option,
              value: !!activeFilters?.customerOwner?.length,
            };
          case "Lead Source":
            return {
              ...option,
              value: !!activeFilters?.leadSource,
            };
          case "Email":
            return {
              ...option,
              value: !!activeFilters?.email,
            };
          case "First Name":
            return {
              ...option,
              value: !!activeFilters?.firstName,
            };
          case "Last Name":
            return {
              ...option,
              value: !!activeFilters?.lastName,
            };
          default:
            return option;
        }
      });
      setDraftSelectedCustomersFilterOptions(updatedDraft);

      if (activeFilters?.customerOwnerIds) {
        setCustomerOwnerIds(activeFilters.customerOwnerIds);
      }

      if (activeFilters?.source?.length) {
        setSource(activeFilters.source);
      }

      if (activeFilters?.email) {
        setEmail(activeFilters.email);
      }

      if (activeFilters?.firstName) {
        setFirstName(activeFilters.firstName);
      }

      if (activeFilters?.lastName) {
        setLastName(activeFilters.lastName);
      }
      if (activeFilters?.createdByUserIds?.length) {
        setCreatedByUserIds(activeFilters.createdByUserIds);
      }
      if (activeFilters?.dateOfBirthFrom && activeFilters?.dateOfBirthTo) {
        setDateOfBirthRange(["Custom"]);
        setDateOfBirthFrom(dayjs(activeFilters.dateOfBirthFrom));
        setDateOfBirthTo(dayjs(activeFilters.dateOfBirthTo));
      }
    }
  }, [isOpenFilter]);
  const isAnyFilterSelected = draftSelectedCustomersFilterOptions.some(
    (option: any) => option.value
  );
  const handleChange = (e: any) => {
    // const tempSelectedCustomersFilterOptions = selectedCustomersFilterOptions?.map(
    //   (data: any) => {
    //     return data?.labels === e.target.id
    //       ? { ...data, value: !data?.value }
    //       : data;
    //   },
    // );
    const updatedDraft = draftSelectedCustomersFilterOptions.map((data: any) =>
      data?.labels === e.target.id ? { ...data, value: !data?.value } : data
    );
    const isEmailUnchecked = e.target.id === "Email" && !e.target.checked;
    if (isEmailUnchecked) {
      setEmail("");
      setEmailError("");
    }
    const isEmailChecked = e.target.id === "Email" && e.target.checked;
    if (isEmailChecked) {
      setEmailError("");
    }
    
    const isFirstNameUnchecked =
      e.target.id === "First Name" && !e.target.checked;
    if (isFirstNameUnchecked) {
      setFirstName("");
      setFirstNameError("");
    }
    const isFirstNameChecked = e.target.id === "First Name" && e.target.checked;
    if (isFirstNameChecked) {
      setFirstNameError("");
    }
    
    const isLastNameUnchecked =
      e.target.id === "Last Name" && !e.target.checked;
    if (isLastNameUnchecked) {
      setLastName("");
      setLastNameError("");
    }
    const isLastNameChecked = e.target.id === "Last Name" && e.target.checked;
    if (isLastNameChecked) {
      setLastNameError("");
    }
    
    const isCompanyUnchecked = e.target.id === "Company" && !e.target.checked;
    if (isCompanyUnchecked) {
      setCompany("");
      setCompanyError("");
    }
    const isCompanyChecked = e.target.id === "Company" && e.target.checked;
    if (isCompanyChecked) {
      setCompanyError("");
    }
    
    const isCustomerOwnerUnchecked =
      e.target.id === "Customer Owner" && !e.target.checked;
    if (isCustomerOwnerUnchecked) {
      setCustomerOwnerIds([]);
      setCustomerOwnerIdsError("");
    }
    const isCustomerOwnerChecked = e.target.id === "Customer Owner" && e.target.checked;
    if (isCustomerOwnerChecked) {
      setCustomerOwnerIdsError("");
    }
    
    const isCreatedTimeUnchecked =
      e.target.id === "Date of Birth" && !e.target.checked;
    if (isCreatedTimeUnchecked) {
      setDateOfBirthRange([]);
      setDateOfBirthFrom(null);
      setDateOfBirthTo(null);
      setDateOfBirthFromError("");
      setDateOfBirthToError("");
    }
    const isCreatedTimeChecked = e.target.id === "Date of Birth" && e.target.checked;
    if (isCreatedTimeChecked) {
      setDateOfBirthRangeError("");
      setDateOfBirthFromError("");
      setDateOfBirthToError("");
    }
    
    const isCustomerSourceUnchecked =
      e.target.id === "Customer Source" && !e.target.checked;
    if (isCustomerSourceUnchecked) {
      setSource([]);
      setCustomerSourceError("");
    }
    const isCustomerSourceChecked = e.target.id === "Customer Source" && e.target.checked;
    if (isCustomerSourceChecked) {
      setCustomerSourceError("");
    }
    setDraftSelectedCustomersFilterOptions(updatedDraft);
    // setSelectedCustomersFilters(
    //   tempSelectedCustomersFilterOptions?.filter((data: any) => {
    //     return data?.value;
    //   }),
    // );
  };
  const handleReset = () => {
    const resetFilters = selectedCustomersFilterOptions.map((option: any) => ({
      ...option,
      value: false,
    }));

    setSelectedCustomersFilterOptions(resetFilters);
    setDraftSelectedCustomersFilterOptions(resetFilters);

    setSelectedCustomersFilterOptions(resetFilters);
    setCompany("");
    setCompanyError("");
    setEmail("");
    setEmailError("");
    setFirstName("");
    setFirstNameError("");
    setLastName("");
    setLastNameError("");
    setDateOfBirthRange([]);
    setDateOfBirthFrom(null);
    setDateOfBirthTo(null);
    setDateOfBirthFromError("");
    setDateOfBirthToError("");
    setSource([]);
    setCustomerSourceError("");
    setCreatedByUserIds([]);
    setCustomerSourceError("");
    setCustomerOwnerIds([]);
    setCustomerOwnerIdsError("");
    setSelectedCustomersFilters("");
    props.onApplyFilters({});
    setSelectedCustomersFilters("");
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    if (value.trim() !== "") {
      setEmailError("");
    }
  };
  const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFirstName(value);
    if (value.trim() !== "") {
      setFirstNameError("");
    }
  };
  const handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLastName(value);
    if (value.trim() !== "") {
      setLastNameError("");
    }
  };
  const handleCompanyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCompany(value);
    if (value.trim() !== "") {
      setCompanyError("");
    }
  };
  const handleCustomerSourceChange = (value: string[]) => {
    setSource(value);
    const hasValidValue = value.some((val) => val.trim() !== "");

    if (hasValidValue) {
      setCustomerSourceError("");
    }
  };

  const handleCustomerOwnerChange = (selectedIds: number[]) => {
    setCustomerOwnerIds(selectedIds);

    if (selectedIds.length > 0) {
      setCustomerOwnerIdsError("");
    }
  };
  const handleDateOfBirthRange = (from: Date | null, to: Date | null) => {
    setDateOfBirthFrom(from ? dayjs(from) : null);
    setDateOfBirthTo(to ? dayjs(to) : null);

    // Set range to "Custom" if either date is selected
    if (from || to) {
      setDateOfBirthRange(["Custom"]);
    }

    if (from) setDateOfBirthFromError("");
    if (to) setDateOfBirthToError("");
  };

  const isEmailEnabled = draftSelectedCustomersFilterOptions.find(
    (opt: any) => opt.labels === "Email"
  )?.value;
  const isFirstNameEnabled = draftSelectedCustomersFilterOptions.find(
    (opt: any) => opt.labels === "First Name"
  )?.value;
  const isLastNameEnabled = draftSelectedCustomersFilterOptions.find(
    (opt: any) => opt.labels === "Last Name"
  )?.value;
  const isCompanyEnabled = draftSelectedCustomersFilterOptions.find(
  (opt: any) => opt.labels === "Company"
)?.value;
  const isCreatedTimeEnabled = draftSelectedCustomersFilterOptions.find(
    (opt: any) => opt.labels === "Date of Birth"
  )?.value;
  const isCustomerOwnerEnabled = draftSelectedCustomersFilterOptions.find(
    (opt: any) => opt.labels === "Customer Owner"
  )?.value;
  const isCustomerSourceEnabled = draftSelectedCustomersFilterOptions.find(
    (opt: any) => opt.labels === "Lead Source"
  )?.value;
  const renderFilterField = (optionLabel: string) => {
    switch (optionLabel) {
      case "Email":
        return (
          <EmailFilter
            email={email}
            handleEmailChange={handleEmailChange}
            isEmailEnabled={isEmailEnabled}
            emailError={emailError}
          />
        );
      case "First Name":
        return (
          <FirstNameFilter
            firstName={firstName}
            handleFirstNameChange={handleFirstNameChange}
            isFirstNameEnabled={isFirstNameEnabled}
            firstNameError={firstNameError}
          />
        );
      case "Last Name":
        return (
          <LastNameFilter
            lastName={lastName}
            handleLastNameChange={handleLastNameChange}
            isLastNameEnabled={isLastNameEnabled}
            lastNameError={lastNameError}
          />
        );
      case "Company":
        return (
          <CompanyFilter
            comapny={company}
            handleCompanyChange={handleCompanyChange}
            isCompanyEnabled={isCompanyEnabled}
            companyError={companyError}
          />
        );
      case "Lead Source":
        return (
          <LeadSourceFilter
            value={source}
            onChange={handleCustomerSourceChange}
            isLeadSourceEnabled={isCustomerSourceEnabled}
            leadSourceError={leadSourceError}
          />
        );
      case "Date of Birth":
        return (
          <CreatedTimeFilter
            value={"Custom"}
            onChange={() => {}}
            isCreatedTimeEnabled={
              draftSelectedCustomersFilterOptions.find(
                (opt: any) => opt.labels === "Date of Birth"
              )?.value
            }
            onDateRangeChange={handleDateOfBirthRange}
            createdTimeError={dateOfBirthRangeError}
            createdTimeStartError={dateOfBirthFromError}
            createdTimeEndError={dateOfBirthToError}
            setCreatedTimeFromDate={setDateOfBirthFrom}
            setCretedTimeToDate={setDateOfBirthTo}
            showDropdown={false}
            fromDate={dateOfBirthFrom}
            toDate={dateOfBirthTo}
          />
        );
      case "Customer Owner":
        return (
          <CustomerOwnerFilter
            value={leadOwnerIds}
            onChange={handleCustomerOwnerChange}
            isLeadOwnerEnabled={isCustomerOwnerEnabled}
            leadOwnerIdsError={leadOwnerIdsError}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        );
      default:
        return null;
    }
  };
  const handleApplyFilters = () => {
    let hasError = false;
    if (isEmailEnabled && !email.trim()) {
      setEmailError("Enter Email");
      hasError = true;
    } else {
      setEmailError("");
    }
    if (isFirstNameEnabled && !firstName.trim()) {
      setFirstNameError("Enter First Name");
      hasError = true;
    } else {
      setFirstNameError("");
    }
    if (isLastNameEnabled && !lastName.trim()) {
      setLastNameError("Enter Last Name");
      hasError = true;
    } else {
      setLastNameError("");
    }
    if (isCompanyEnabled && !company.trim()) {
      setCompanyError("Enter Company");
      hasError = true;
    } else {
      setCompanyError("");
    }
    if (
      isCustomerSourceEnabled &&
      (source.length === 0 || source.every((val) => val.trim() === ""))
    ) {
      setCustomerSourceError("Select Lead Source");
      hasError = true;
    } else {
      setCustomerSourceError("");
    }
    if (isCustomerOwnerEnabled && leadOwnerIds.length === 0) {
      setCustomerOwnerIdsError("Select Customer Owner");
      hasError = true;
    } else {
      setCustomerOwnerIdsError("");
    }
    if (isCreatedTimeEnabled) {
      if (dateOfBirthRange.length === 0) {
        setDateOfBirthRangeError("Select Date of Birth");
        hasError = true;
      } else {
        setDateOfBirthRangeError("");
      }
      if (dateOfBirthRange.includes("Custom")) {
        if (!dateOfBirthFrom) {
          setDateOfBirthFromError("From date is required");
          hasError = true;
        } else if (
          !dayjs(dateOfBirthFrom).isValid() ||
          dayjs(dateOfBirthFrom).year() < 1900
        ) {
          setDateOfBirthFromError("Invalid date");
          hasError = true;
        } else {
          setDateOfBirthFromError("");
        }

        if (!dateOfBirthTo) {
          setDateOfBirthToError("To date is required");
          hasError = true;
        } else if (
          !dayjs(dateOfBirthTo).isValid() ||
          dayjs(dateOfBirthTo).year() < 1900
        ) {
          setDateOfBirthToError("Invalid date");
          hasError = true;
        } else {
          setDateOfBirthToError("");
        }
        if (
          dateOfBirthFrom &&
          dateOfBirthTo &&
          dayjs(dateOfBirthFrom).isValid() &&
          dayjs(dateOfBirthTo).isValid() &&
          dayjs(dateOfBirthFrom).isAfter(dayjs(dateOfBirthTo))
        ) {
          setDateOfBirthFromError("From date cannot be greater than end date");
          setDateOfBirthToError("To date cannot be less than start date");
          hasError = true;
        }
      } else {
        setDateOfBirthFromError("");
        setDateOfBirthToError("");
      }
    }

    if (hasError) {
      return;
    }
    onApplyFilters({
      email: email,
      firstName: firstName,
      lastName: lastName,
      company: company,
      dateOfBirthFrom: dateOfBirthFrom,
      dateOfBirthTo: dateOfBirthTo,
      createdByUserIds: createdByUserIds,
      customerOwnerIds: leadOwnerIds,
      leadSource: source,
    });
    setSelectedCustomersFilterOptions(draftSelectedCustomersFilterOptions);
    setSelectedCustomersFilters(
      draftSelectedCustomersFilterOptions.filter((data: any) => data.value)
    );
    setIsOpenFilter(false);
  };
  return (
    <div className="customer-filter-options-wrapper">
      <div className="customer-filter-options-container">
        <div className="header-wrapper">
          <div className="customer-filter-options-container-header">
            <div className="customer-filter-options-container-header-text">
              Filters
            </div>
            <div className="customer-filter-options-container-header-icon">
              <img
                src={closeIcon}
                alt="Filter Icon"
                onClick={() => setIsOpenFilter(!isOpenFilter)}
              />
            </div>
          </div>
          <div className="customer-filter-options-container-subtext">
            Filter By Fields
          </div>
        </div>
        <div className="customer-filter-options-container-list">
          {draftSelectedCustomersFilterOptions
            .filter((option: any) =>
              isAssign
                ? true
                : option.labels !== "Assigned Partner" &&
                  option.labels !== "Customer Source"
            )
            .map((option: any) => (
              <div key={option.labels}>
                <label
                  htmlFor={option.labels}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <Checkbox
                    checked={option?.value}
                    onChange={handleChange}
                    id={option.labels}
                  />
                  <ListItemText primary={option.labels} />
                </label>
                {option?.value && renderFilterField(option.labels)}
              </div>
            ))}
          {isAnyFilterSelected && (
            <div className="customer-filter-buttons">
              <button
                className="cancel-button"
                onClick={() => {
                  handleReset();
                }}
              >
                Reset
              </button>
              <button
                className="next-button-wrapper"
                type="submit"
                onClick={handleApplyFilters}
              >
                Apply
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerFilterOptions;
